import { Variable } from '../../services/api/departmentVariablesService';
import { VariableDefault, VariableSection } from './utils/variableTypes';
import { DepartmentUser } from './setup-wizard/WizardVariableForm';
import VariableRow from './variable-row/VariableRow';
import { Card } from '../ui/card';

interface SectionCardProps {
    section: VariableSection;
    icon: React.ReactNode;
    savedVariables: Variable[];
    users: DepartmentUser[];
    onSaved: () => Promise<void>;
}

export default function SectionCard({
    section,
    icon,
    savedVariables,
    users,
    onSaved,
}: SectionCardProps) {
    return (
        <Card className="border-subtle overflow-hidden">
            {/* Header */}
            <div className="p-4 flex items-center gap-4">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    {icon}
                </div>
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <span className="font-semibold">{section.title}</span>
                    </div>
                    <p className="text-sm text-muted-foreground">
                        {section.description}
                    </p>
                </div>
            </div>

            {/* Rows */}
            <div className="border-t border-subtle">
                {section.variables.map((def) => {
                    const saved = savedVariables.find(
                        (v) => v.name === def.name
                    );
                    return (
                        <VariableRow
                            key={def.name}
                            def={def}
                            savedVariable={saved}
                            users={users}
                            isCustom={false}
                            onSaved={onSaved}
                        />
                    );
                })}
            </div>
        </Card>
    );
}
